export default "__VITE_ASSET__0rAvLU_M__"